module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.questions && _vm.values) ? _c('div', _vm._l((_vm.questionIds), function(qid) {
    return _c('form-question', {
      key: qid,
      staticClass: "light-frame",
      attrs: {
        "question": _vm.questions[qid],
        "values": _vm.values,
        "value": _vm.values[qid],
        "error-message": _vm.errorMessages[_vm.questions[qid].a.type]
      },
      on: {
        "answer-value": function($event) {
          return _vm.valueUpdated(qid, $event)
        }
      }
    })
  }), 1) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-446bfa7e","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/PaymentWhyForm.vue
// module id = 732
// module chunks = 3